import HTTPClientRINDAT from "./http-client";
import REGIONAL_IDS from "@/utils/regionalIds";

class LightningCounterService {
  async getRegionalLightningCounter(id, date, interval) {
    const httpClient = new HTTPClientRINDAT();
    const api = await httpClient.configure();

    const params = new URLSearchParams({
      datetimeEnd: date,
      intervalMinutes: interval,
    });

    if (id) {
      params.append("regionalIds", id);
    } else {
      params.append("regionalIds", REGIONAL_IDS);
    }

    return api.get(`/copelregional_lightningcounter?${params.toString()}`);
  }

  async getAgenciesLightningCounter(id, date, interval) {
    const httpClient = new HTTPClientRINDAT();
    const api = await httpClient.configure();
    return api.get(`/copelagency_lightningcounter?agencyIds=${id}&datetimeEnd=${date}&intervalMinutes=${interval}`);
  }
  async getCityLightningCounter(id, date, interval) {
    const httpClient = new HTTPClientRINDAT();
    const api = await httpClient.configure();
    return api.get(`/copelcity_lightningcounter?cityIds=${id}&datetimeEnd=${date}&intervalMinutes=${interval}`);
  }
}

export default new LightningCounterService();
